import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "wrapper-background"
};
const _hoisted_2 = {
  class: "g1g__cards_wrapper"
};
const _hoisted_3 = {
  class: "g1g__inlinecard"
};
const _hoisted_4 = {
  class: "row row--constrained"
};
const _hoisted_5 = {
  class: "col-lg-4 col-md-4 col-sm-6 card-size-limiter"
};
const _hoisted_6 = {
  class: "content_container"
};
const _hoisted_7 = {
  ref: "videoAssess",
  class: "myVideoClass",
  style: {
    "object-fit": "cover"
  },
  loop: "",
  autoplay: "",
  muted: "",
  playsinline: "",
  preload: "metadata",
  "aria-label": "Assess"
};
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[5] || (_cache[5] = _createElementVNode("h2", {
    class: "heading"
  }, "How to use G1G", -1)), _createElementVNode("div", _hoisted_4, [_cache[3] || (_cache[3] = _createElementVNode("div", {
    class: "col-lg-4 col-md-4 col-sm-6 card-size-limiter"
  }, [_createElementVNode("div", {
    class: "content_container"
  }, [_createElementVNode("h4", {
    class: "title"
  }, "Assess"), _createElementVNode("video", {
    class: "myVideoClass",
    style: {
      "object-fit": "cover"
    },
    loop: "",
    autoplay: "",
    muted: "",
    playsinline: "",
    preload: "metadata",
    "aria-label": "Assess"
  }, [_createElementVNode("source", {
    src: "https://g1gv3.s3.us-west-1.amazonaws.com/frontend-assets/why-g1g/itira.mp4",
    type: "video/mp4"
  }), _createTextVNode(" Your browser does not support the video tag. ")]), _createElementVNode("p", {
    class: "content"
  }, " Share trip details with ITIRA, your AI guide. It analyzes your trip. Aligns with custom safety packages. Prep work? A breeze. ")])], -1)), _cache[4] || (_cache[4] = _createElementVNode("div", {
    class: "col-lg-4 col-md-4 col-sm-6 card-size-limiter"
  }, [_createElementVNode("div", {
    class: "content_container"
  }, [_createElementVNode("h4", {
    class: "title"
  }, "Choose"), _createElementVNode("video", {
    class: "myVideoClass",
    style: {
      "object-fit": "cover"
    },
    loop: "",
    autoplay: "",
    muted: "",
    playsinline: "",
    preload: "metadata",
    "aria-label": "Choose"
  }, [_createElementVNode("source", {
    src: "https://g1gv3.s3.us-west-1.amazonaws.com/frontend-assets/why-g1g/choose.mp4",
    type: "video/mp4"
  }), _createTextVNode(" Your browser does not support the video tag. ")]), _createElementVNode("p", {
    class: "content"
  }, " Select personalized travel insurance. Solo adventures. Family vacations. Pick coverage that fits. Focus on experiences ahead. ")])], -1)), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_cache[1] || (_cache[1] = _createElementVNode("h4", {
    class: "title"
  }, "Protect", -1)), _createElementVNode("video", _hoisted_7, _cache[0] || (_cache[0] = [_createElementVNode("source", {
    src: "https://g1gv3.s3.us-west-1.amazonaws.com/frontend-assets/why-g1g/protect.mp4",
    type: "video/mp4"
  }, null, -1), _createTextVNode(" Your browser does not support the video tag. ")]), 512), _cache[2] || (_cache[2] = _createElementVNode("p", {
    class: "content content--final"
  }, " With our app, you're never alone. Real-time assistance. Medical emergencies. Unexpected delays. Smooth. Enjoyable. ", -1))])])])])])]);
}